import type React from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/landing/template/pageContext';

export const TemplateErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw error;
};
